import React from 'react';
import { Link } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import SEO from '../../components/SEO';
import './styles.css';

export default function EmailChangeRejected() {
  return (
    <div className="email-change-page">
      <SEO
        title="Email Change Rejected | EternaVaults"
        description="The email change request has been rejected."
      />
      <div className="email-change-container">
        <div className="email-change-card">
          <div className="reject-icon">
            <XCircle size={64} />
          </div>
          <h1>Email Change Rejected</h1>
          <p className="email-change-message">
            The email change request has been rejected. Your email address remains unchanged.
          </p>
          <p className="email-change-note">
            If you did not reject this change and are concerned about account security, please contact support immediately.
          </p>
          <div className="email-change-actions">
            <Link to="/dashboard" className="btn-primary">
              Return to Dashboard
            </Link>
            <a href="mailto:support@eternavaults.com" className="btn-secondary">
              Contact Support
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}


